import { Component, OnInit } from '@angular/core';
import { TrainingService } from 'app/_services/training.service';

@Component({
  selector: 'app-site-induction-report',
  templateUrl: './site-induction-report.component.html',
})
export class SiteInductionReportComponent implements OnInit {
  generatedReportData = [];

  constructor(private trainingService: TrainingService) {}

  ngOnInit() {}

  public generateInductionReport() {
    this.trainingService.getSiteInductionReport();
  }
}
